module.exports = __webpack_public_path__ + "static/media/bg-pattern-footer-mobile.c33e3a52.svg";